import React from "react";
import { useTranslation } from "react-i18next";
import { h } from "../../constant/images";
import icon1 from "../../assets/images/icon/we-offer.webp";
import icon2 from "../../assets/images/icon/we-strive.webp";
import spSection from "../../assets/images/all-img/sp-section.webp";
const AboutThree = () => {
  const { t } = useTranslation(); // Initialize translation

  return (
    <div className="about-area section-padding-top pb-16 relative z-[1]">
      {/* Background Element */}
      <div className="absolute right-[7%] top-[20%] z-[-1] hidden xl:block">
        <img src={h} alt="" />
      </div>

      <div className="container">
        <div className="grid grid-cols-12 xl:gap-[70px] lg:gap-10 gap-6">
          {/* Left Side - Image */}
          <div className="xl:col-span-7 lg:col-span-6 col-span-12">
            <img src={spSection} alt={t("about_three.image_alt")} />
          </div>
          {/* Right Side - Text Content */}
          <div className="xl:col-span-5 lg:col-span-6 col-span-12">
            <div className="mini-title">{t("about_three.mini_title")}</div>
            <h4 className="column-title">{t("about_three.title")} </h4>
            {/* Features List */}
            <ul className="list-item space-y-6 pt-8">
              {/* First Feature */}
              <li className="flex">
                <div className="flex-none mr-6">
                  <div className="h-20 w-20 rounded-full bg-white shadow-box10 flex flex-col justify-center items-center">
                    <img src={icon1} alt="" />
                  </div>
                </div>
                <div className="flex-1">
                  <div>{t("about_three.features.0.description")}</div>
                </div>
              </li>

              {/* Second Feature */}
              <li className="flex">
                <div className="flex-none mr-6">
                  <div className="h-20 w-20 rounded-full bg-white shadow-box10 flex flex-col justify-center items-center">
                    <img src={icon2} alt="" />
                  </div>
                </div>
                <div className="flex-1">
                  <div>{t("about_three.features.1.description")}</div>
                </div>
              </li>
            </ul>{" "}
            {/* End Features List */}
          </div>{" "}
          {/* End Right Side */}
        </div>
      </div>
    </div>
  );
};

export default AboutThree;
